<div class="container mt-5">

  <div class="grid-container">

    <!-- Searchbar -->
    <div class="searchbar">
      <div class="form-group cmp-input-search-button mt-2 mb-4 mb-lg-50">
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <svg class="icon icon-md">
                <use href="/bootstrap-italia/dist/svg/sprites.svg#it-search"></use>
              </svg>
            </div>
          </div>
          <input (keyup.enter)="triggerSearch()" type="search" class="form-control" id="input-group-1"
            name="input-group-1" placeholder="Cerca.." [(ngModel)]="searchTerm" (input)="onInputChange()" />
        </div>
        <button type="button" class="btn btn-primary" [disabled]="!searchTerm || searchTerm.trim().length < 3"
          (click)="triggerSearch()">
          Cerca
        </button>
      </div>
    </div>

    <!-- Filter -->
    <div class="filter">
      <fieldset>
        <legend class="h6 text-uppercase category-list__title">
          Archivio
        </legend>
        <div class="category-list pb-4">
          <div class="form-check">
            <div class="checkbox-body border-light py-1">
              <input id="search-archive" type="checkbox" (change)="searchArchived()" [checked]="isArchiveSearch" />
              <label for="search-archive" class="subtitle-small_semi-bold mb-0 category-list__list active">
                Cerca in Archivio
              </label>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset *ngIf="searchService.typeFilters().length">
        <legend class="h6 text-uppercase category-list__title">
          Tipologie
        </legend>
        <div class="category-list pb-4">
          <ul>
            <li *ngFor="let typeFilter of searchService.typeFilters()">
              <div class="form-check">
                <div class="checkbox-body border-light py-1">
                  <input (change)="searchService.toggleTypeFilter(typeFilter.type)" type="checkbox"
                    [id]="typeFilter.type" name="category" [value]="typeFilter.type"
                    [checked]="searchService.activeFilters().type.includes(typeFilter.type)" />
                  <label [for]="typeFilter.type" class="subtitle-small_semi-bold mb-0 category-list__list active">
                    {{ typeFilter.type }} ({{ typeFilter.count }})
                  </label>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </fieldset>

      <fieldset *ngIf="searchService.tagFilters().length">
        <legend class="h6 text-uppercase category-list__title">
          Argomenti
        </legend>
        <div class="category-list pb-4">
          <ul>
            <li *ngFor="let tagFilter of searchService.tagFilters()">
              <div class="form-check">
                <div class="checkbox-body border-light py-1">
                  <input (change)="searchService.toggleTagFilter(tagFilter.name)" type="checkbox" [id]="tagFilter.name"
                    name="tag" [value]="tagFilter.name"
                    [checked]="searchService.activeFilters().tags.includes(tagFilter.name)" />
                  <label [for]="tagFilter.name" class="subtitle-small_semi-bold mb-0 category-list__list">
                    {{ tagFilter.name }} ({{ tagFilter.count }})
                  </label>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </fieldset>
    </div>

    <!-- Results -->
    <div class="results" *ngIf="searchService.filteredResults().length; else noResult">
      <div class="d-flex justify-content-between align-items-center border-bottom border-light pb-3 mb-2">
        <h2 class="visually-hidden" id="search-result">Risultati di ricerca</h2>
        <span class="search-results u-grey-light">
          <span class="numResult">{{ searchService.filteredResults().length }}</span> Risultati
        </span>
        <button type="button" class="btn p-0 pe-2 btn-filtra" (click)="toggleFilter()">
          <span class="rounded-icon">
            <svg class="icon icon-primary icon-xs" aria-hidden="true">
              <use href="/bootstrap-italia/dist/svg/sprites.svg#it-funnel"></use>
            </svg>
          </span>
          <span class="t-primary title-xsmall-semi-bold ms-1">Filtra</span>
        </button>
        <button type="button" class="btn d-none d-lg-block btn-result" [disabled]="
            !searchService.activeFilters().type.length && 
            !searchService.activeFilters().tags.length" (click)="searchService.resetFilters()">
          Rimuovi tutti i filtri
        </button>
      </div>

      <div class="container p-0">
        <div class="row flex-column-reverse flex-lg-row">
          <div class="col-12 pt-3">
            <div *ngFor="let item of searchService.filteredResults()">
              <app-card [link]="item.url" [title]="item.title" [description]="item.description"
                [tipologia]="item.category"></app-card>
            </div>
          </div>
        </div>
      </div>

      <div class="container p-0" *ngIf="!searchService.noMoreResults()">
        <div class="d-flex justify-content-center">
          <button type="button"
            class="btn btn-outline-primary pt-15 pb-15 pl-90 pr-90 mb-30 mb-lg-50 full-mb text-button"
            (click)="loadMoreResults()">
            Carica altri risultati
          </button>
        </div>
      </div>
    </div>

    <ng-template #noResult>
      <div class="d-flex justify-content-between align-items-center" *ngIf="searchTerm && !searchResults.length && !this.searchService.loading()">
        <h2 class="visually-hidden" id="search-result">Risultati di ricerca</h2>
        <span class="search-results u-grey-light">
          <span class="numResult">Nessun risultato trovato</span>
        </span>
       
      </div>

    </ng-template>


  </div>
  <div *ngIf="this.searchService.loading()" class="d-flex justify-content-center align-items-center mb-5">
    <div class="progress-spinner progress-spinner-active spinner-lg">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>